import { createFileRoute } from '@tanstack/react-router';
import ClassManagement, {
  type ClassManagementSection,
} from '../../../components/portals/ClassManagement';
import { useManagersPortal } from '../../../contexts/ManagersPortalContext';

type ClassesSearch = {
  section?: ClassManagementSection;
};

export const Route = createFileRoute('/portal/managers/classes')({
  validateSearch: (search: Record<string, unknown>): ClassesSearch => {
    const section = search.section;
    if (
      section === 'classes' ||
      section === 'daily' ||
      section === 'weekly' ||
      section === 'fourWeek'
    ) {
      return { section };
    }
    return {};
  },
  component: ManagersClassesContent,
});

function ManagersClassesContent() {
  const { section } = Route.useSearch();
  const {
    students,
    classes,
    setClasses,
    teachers,
    handleStudentUpdate,
    handleAttendanceUpdate,
    assignStudentsToClass,
    bulkGraduateStudents,
    schoolYears,
    selectedSchoolYearId,
    setSelectedSchoolYearId,
    copySchoolYearPlacements,
  } = useManagersPortal();
  return (
    <ClassManagement
      classes={classes}
      setClasses={setClasses}
      students={students}
      teachers={teachers}
      onStudentUpdate={handleStudentUpdate}
      onAssignStudentsToClass={assignStudentsToClass}
      onBulkGraduateStudents={bulkGraduateStudents}
      onAttendanceUpdate={handleAttendanceUpdate}
      initialSection={section ?? 'classes'}
      schoolYears={schoolYears}
      selectedSchoolYearId={selectedSchoolYearId}
      onSelectSchoolYear={setSelectedSchoolYearId}
      onCopySchoolYearPlacements={copySchoolYearPlacements}
    />
  );
}
